import { Component, Input, OnInit } from '@angular/core';
import { ReviewIdEnum } from '@app/core';
import { ProductIdNameService } from '@app/core/services/product-id-name.service';

@Component({
    selector: 'ins-review-section',
    templateUrl: 'review-section.component.html',
    styleUrls: ['review-section.component.scss'],
})
export class ReviewSectionComponent implements OnInit {
    @Input() productName: string;
    @Input() reviewId: ReviewIdEnum;

    public productLink: string;

    ngOnInit(): void {
        const data = ProductIdNameService.getDataByReviewId(this.reviewId);
        this.productLink = data?.appRoute;
    }
}
